<template>
  <div class="ec-question-group">
    <question
      v-for="question in questions"    
      ref="questions"  
      :key="question.id"
      :question="question" />
  </div>
</template>
<style lang="scss">
</style>
<script>
    import { forEach } from 'lodash'
    import Question from './Question.vue'
    
    export default {
        name: "QuestionsGroup",
        components: { Question },
        props: {
            questions: {
                type: Array,
                required: true
            }
        },
        data:function() {
            return {
                classStyle: {
                    'fadeOutUp': false,
                    'zoomInLeft': true
                }
            }
        },
        methods: {
            created() {
                this.$event.$on('next', () => {
                    //this.classStyle.fadeOutDown = true;
                })
            },
            getResponseData() {
                let responseData = []

                forEach(this.$refs.questions, function (question) {
                    responseData.push(question.getResponseData())
                })

                return responseData
            },
        }
    }
</script>
